import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  inject,
  OnInit,
  Output,
  signal,
} from '@angular/core';
import { startWith } from 'rxjs';

import {
  ConfigService,
  StoreService,
  TopBarItem,
  TranslateDirective,
} from '@speedy/core';

@Component({
  selector: 'app-top-bar-menu',
  templateUrl: './top-bar-menu.component.html',
  styleUrls: ['./top-bar-menu.component.scss'],
  standalone: true,
  imports: [TranslateDirective],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TopBarMenuComponent implements OnInit {
  private readonly config = inject(ConfigService);
  private readonly storeService = inject(StoreService);

  @Output() itemClicked = new EventEmitter<void>();

  topBarLinksItems = signal<TopBarItem[]>([]);

  ngOnInit() {
    this.storeService.store$.pipe(startWith(null)).subscribe(() => {
      this.getTopBarLinks();
    });
  }

  getTopBarLinks() {
    const topLinks = this.config.getConfig('speedy/header/speedylinks');

    if (!topLinks) return;

    const topBarItems: { [key: string]: TopBarItem } = JSON.parse(topLinks);
    const parentItems: { [key: number]: TopBarItem } = {};

    const result: TopBarItem[] = [];

    Object.values(topBarItems)?.forEach((item) => {
      if (parseInt(item.link_parent_code) === 0) {
        item.sub_items = [];
        parentItems[parseInt(item.link_code)] = item;
        result.push(item);
      } else {
        const parentItem = parentItems[parseInt(item.link_parent_code)];
        if (parentItem) {
          parentItem.sub_items.push(item);
        }
      }
    });

    this.topBarLinksItems.set(result.filter((x) => x !== undefined && x !== null));
  }

  isDropDown(item: TopBarItem) {
    return item.sub_items && item.sub_items.length > 0;
  }
}
